/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1PersonIdContactData202,
  PutApiV1PersonIdContactData400,
  PutApiV1PersonIdContactData401,
  PutApiV1PersonIdContactData404,
  PutApiV1PersonIdContactData500,
  PutApiV1PersonIdContactDataMutationRequest,
  PutApiV1PersonIdContactDataMutationResponse,
  PutApiV1PersonIdContactDataPathParams,
} from "../../types/personRegisterController/PutApiV1PersonIdContactData.ts";
import { personContactDataViewModelSchema } from "../personContactDataViewModelSchema.ts";
import { updateContactDataRequestSchema } from "../updateContactDataRequestSchema.ts";

export const putApiV1PersonIdContactDataPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1PersonIdContactDataPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1PersonIdContactData202Schema = z.lazy(
  () => personContactDataViewModelSchema,
) as unknown as ToZod<PutApiV1PersonIdContactData202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1PersonIdContactData400Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdContactData400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1PersonIdContactData401Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdContactData401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1PersonIdContactData404Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdContactData404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1PersonIdContactData500Schema =
  z.any() as unknown as ToZod<PutApiV1PersonIdContactData500>;

export const putApiV1PersonIdContactDataMutationRequestSchema = z.lazy(
  () => updateContactDataRequestSchema,
) as unknown as ToZod<PutApiV1PersonIdContactDataMutationRequest>;

export const putApiV1PersonIdContactDataMutationResponseSchema = z.lazy(
  () => putApiV1PersonIdContactData202Schema,
) as unknown as ToZod<PutApiV1PersonIdContactDataMutationResponse>;
